export enum SearchWidgetLabelsEnum {
  NARA_MIG = 'Nära mig',
}
